/**
 * FamilyMediaFrame — the reusable square (1:1) archive frame for the Lore
 * Family Explorer. Renders an elegant placeholder (concentric rings + FAMILY
 * NFT label + technical corner brackets) until `family.image` is supplied.
 *
 * Once the official square NFT is added to the family data, the frame
 * automatically switches to the image using object-fit: cover — no layout
 * changes required.
 */
export function FamilyMediaFrame({ family }) {
  const hasImage = Boolean(family?.image);
  const label = `${String(family?.index).padStart(2, "0")} · ${family?.name?.toUpperCase()}`;

  return (
    <figure
      data-testid={`family-media-frame-${family.id}`}
      aria-label={family.alt}
      className="prophets-lore-frame"
    >
      <span aria-hidden="true" className="prophets-lore-frame-corner prophets-lore-frame-corner--tl" />
      <span aria-hidden="true" className="prophets-lore-frame-corner prophets-lore-frame-corner--tr" />
      <span aria-hidden="true" className="prophets-lore-frame-corner prophets-lore-frame-corner--bl" />
      <span aria-hidden="true" className="prophets-lore-frame-corner prophets-lore-frame-corner--br" />

      <div className="prophets-lore-frame-inner">
        {hasImage ? (
          <img
            src={family.image}
            alt={family.alt}
            width="1000"
            height="1000"
            decoding="async"
            className="prophets-lore-frame-image"
            draggable={false}
          />
        ) : (
          <div className="prophets-lore-frame-placeholder" aria-hidden="true">
            <span className="prophets-lore-frame-ring" />
            <span className="prophets-lore-frame-ring prophets-lore-frame-ring--mid" />
            <span className="prophets-lore-frame-ring prophets-lore-frame-ring--inner" />
            <span className="p-mono prophets-lore-frame-placeholder-label">FAMILY NFT</span>
          </div>
        )}

        {/* Bottom technical strip — index + family name, always visible */}
        <div className="prophets-lore-frame-strip" aria-hidden="true">
          <span className="prophets-lore-frame-strip-tick" />
          <span className="p-mono prophets-lore-frame-strip-label">{label}</span>
        </div>

        {/* Subtle scan-line reveal on family change */}
        <span aria-hidden="true" className="prophets-lore-frame-scan" />
      </div>
    </figure>
  );
}
